<template>
    <div class="index">
        <!-- appbar -->
        <v-header :seller="seller" :is-seft="1"></v-header>

        <!-- content -->
        <mu-container>
            <!--  <div style="position:relative;top:0px;width:100%;height:50%;text-align:center;">-->
            <!--<mu-button large color="red" class="nav-btn" @click="jumpBufftPay()">
        <mu-avatar style="margin-left:-20px;" size="48">
            <img src="../assets/image/payment.png">
        </mu-avatar>
        <div class="nav-header-title">
            <div class="nav-title">Pay</div>
            <div class="nav-sub-title">park</div>
        </div>
        <div class="nav-header-icon">
            <mu-icon size="42" value="chevron_right" color="white"></mu-icon>
        </div>
    </mu-button>-->
            <!--<mu-card style="width: 100%; max-width: 375px; margin: 0 auto;">
        <mu-card-media title="Free Park" >
            <img src="../assets/image/paypark.png" />
        </mu-card-media>
    </mu-card>-->
            <!--<div class="link-title" @click="jumpPayOrderList">View payment order list</div>
    </div>

    <div style="position:relative;top:180px;width:100%;height:50%;text-align:center;background-image:url('../assets/image/drink.jpg')">
        <mu-button large color="red" class="nav-btn" @click="jumpBufft()">
            <mu-avatar style="margin-left:-20px;" size="48">
                <img src="../assets/image/free.png">
            </mu-avatar>
            <div class="nav-header-title">
                <div class="nav-title">Free</div>
                <div class="nav-sub-title">park</div>
            </div>
            <div class="nav-header-icon">
                <mu-icon size="42" value="chevron_right" color="white"></mu-icon>
            </div>
        </mu-button>
        <div class="link-title" @click="jumpFreeOrderList">View free order list</div>
    </div>-->

            <mu-grid-list class="gridlist-demo"  :cols="1" :cell-height="270">
                <mu-sub-header style="text-align:center;color:#000000;font-size:18px;font-weight:600;background-color:#ffffff;">All you can eat</mu-sub-header>
                <mu-grid-tile  id="divParPark" >
                    <img src="../assets/image/paypark.png" @click="jumpBufftPay()"/>
                    <span slot="title" @click="jumpBufftPay()">
                        Pay Park
                        <mu-icon value="chevron_right"  style="position:absolute;top:12px;left:80px;"></mu-icon>
                    </span>
                    <mu-button slot="action" icon style="margin-right:10px;z-index:9999;"  @click="jumpPayOrderList">
                        <mu-icon value="assignment_turned_in" ></mu-icon>
                    </mu-button>
                </mu-grid-tile>

                <mu-grid-tile  id="divFreePark" >
                    <img src="../assets/image/freepark.png"  @click="jumpBufft()"/>
                    <span slot="title" @click="jumpBufft()">
                        Free Park
                        <mu-icon value="chevron_right" style="position:absolute;top:12px;left:85px;"></mu-icon>
                    </span>
                    <mu-button slot="action" icon style="margin-right:10px;z-index:9999;"  @click="jumpFreeOrderList" >
                        <mu-icon value="assignment_turned_in"></mu-icon>
                    </mu-button>
                </mu-grid-tile>
            </mu-grid-list>
        </mu-container>
    </div>
</template>
<script>
    import header from '../components/Header';

    export default {
        name: 'BuffetSelect',
        data() {
            return {
                seller: {}
            }
        },
        components: {
            'v-header': header
        },
        mounted() {
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
        },
        created() {

        },
        computed: {
        },
        methods: {
            jumpBufftPay() {
                this.$router.push({ path: '/buffetPay' });
            },
            jumpBufft() {
                this.$router.push({ path: '/buffet'});
            },
            jumpPayOrderList() {
                this.$router.push({
                    path: '/orderList', query: {
                        isSeft: 0
                    }
                })
            },
            jumpFreeOrderList() {
                this.$router.push({
                    path: '/orderList', query: {
                        isSeft:1
                    }
                })
            },
            getImgUrl(image) {
                if (image == undefined || image == 'undefined') {
                    return '../static/img/default.png';
                }
                return this.ImageBaseUrl + image;
            }
        },
        activated() {
            
        }
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .nav-btn {
        background-color: #da5b3a !important;
        height: 80px;
        border-radius: 10px;
        padding: 0px;
        text-transform: unset;
    }

    .nav-header-title {
        margin-left: 15px;
    }

        .nav-header-title .nav-title {
            line-height: 20px;
            font-size: 15px;
            font-weight: 600;
            text-align: center;
        }

        .nav-header-title .nav-sub-title {
            line-height: 20px;
            font-size: 13px;
            text-align: center;
        }

    .nav-header-icon {
        line-height: 80px;
       margin-top:30px;
        vertical-align: middle;
        margin-right: -20px;
    }
    .link-title {
        margin-top: 15px;
        color: #da5b3a;
        font-size: 14px;
    }

</style>



// WEBPACK FOOTER //
// src/components/BuffetMain.vue